import React, { useState, useContext } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { ClaimTower } from '../../components';
import { ViewTower } from '../../components/ViewTower';
import { PolygonNetworkInfo } from '../../services/networkServices';
import { Web3Context } from '../../web3/Web3Context';
import styles from './EarnTower.module.scss';
import LogoCDH from '../../assets/imgs/cdh-logo.png';
import IconAndroid from '../../assets/icons/icon-android.png';
import IconApple from '../../assets/icons/icon-apple\ store.png';
import { useCookies } from 'react-cookie';

const CHAIN_ID = parseInt(process.env.REACT_APP_POLYGON_CHAIN_ID);

const EarnTower = () => {
    window.scrollTo(0, 0);
    const [t] = useTranslation();
    const [showViewTower, setShowViewTower] = useState(true);
    const [cookies, setCookies] = useCookies(['showWelcomeModalEarnTower']);
    const { networkId, switchNetwork } = useContext(Web3Context);

    const cdhGpLink = "https://go.onelink.me/bUzl/9c836b67";
    const cdhAppStoreLink = "https://go.onelink.me/VHLW/e01c1c3f";

    const handleNetworkSwitch = () => {
        switchNetwork(PolygonNetworkInfo);
    }

    return (
        <>
            {networkId !== null && networkId !== CHAIN_ID &&
                <div className={styles.network_switch_banner}>
                    <div className={styles.network_switch_text}>{t('USE_POLYGON_NETWORK_FOR_DAILY_REWARDS_CLAIM')}</div>
                    <div className={styles.switch_btn} onClick={handleNetworkSwitch}>{t('SWITCH_BTN')}</div>
                </div>
            }
            
            <div className={styles.earn_tower_container}>
               {showViewTower ? <ViewTower setShowViewTower={setShowViewTower} /> : <ClaimTower />}
            </div>

            <Modal 
                show={cookies.showWelcomeModalEarnTower !== 'false'} 
                className={styles.welcome_message_modal} 
                contentClassName={styles.welcome_message_modalContent} 
                dialogClassName={styles.welcome_message_modalDialog} 
                onHide={ () => setCookies('showWelcomeModalEarnTower', 'false') } 
                centered>
                <Modal.Body className={styles.welcome_message_modalBody}>
                    <div className={styles.welcome_message_title}>
                        { t('WELCOME_TO_EARN_TOWER') }
                    </div>
                    <div className={styles.welcome_message_description}>
                        <p>
                            {t('EARN_TOWER_WELCOME_MSG_DESCRIPTION_FIRST')}
                        </p>
                        
                        <p>
                            <span>{ t('EARN_TOWER_WELCOME_MSG_DESCRIPTION_SECOND_ONE') }</span>&nbsp;
                            <span>
                                <a target="_blank" rel="noopener noreferrer" href={'https://medium.com/tower-token/link-your-metamask-to-see-how-much-tower-you-earned-play-to-earn-events-for-july-and-august-2021-5df508a76392'}>{ t('ARTICLE') }</a>
                            </span>&nbsp;
                            <span>{ t('EARN_TOWER_WELCOME_MSG_DESCRIPTION_SECOND_TWO') }</span>
                        </p>

                        <p>
                            <span>{ t('EARN_TOWER_WELCOME_MSG_DESCRIPTION_THIRD_ONE') }</span>&nbsp;
                            <span>
                                <a target="_blank" rel="noopener noreferrer" href={'https://medium.com/tower-token/crazy-defense-heroes-play-and-earn-events-are-now-exclusive-for-tower-battle-card-nft-holders-1f080172ab9c'}>{ t('ARTICLE') }</a>
                            </span>&nbsp;
                            <span>{ t('EARN_TOWER_WELCOME_MSG_DESCRIPTION_THIRD_TWO') }</span>
                        </p>
                    </div>
                    <div className={styles.welcome_message_btn_section}>
                        <Button className={styles.welcome_message_btn} onClick={() => setCookies('showWelcomeModalEarnTower', 'false')}>
                            { t('GOT_IT')}
                        </Button>
                    </div>
                </Modal.Body>

                <Modal.Footer className={styles.welcome_message_footer}>
                    <div className={styles.welcome_message_bottom_banner}>
                        <div className={styles.banner_cdh_logo}>
                            <img src={LogoCDH} alt="crazy-defense-heroes" />
                        </div>
                        <div className={styles.banner_text}>
                            { t('WANNA_PLAY_CDH') }
                        </div>
                        <div className={styles.app_link}>
                            <a target="_blank" href={cdhGpLink} rel="noopener noreferrer">
                                <img src={IconAndroid} alt="icon-play-store" />
                            </a>
                        </div>
                        <div className={styles.app_link}>
                            <a target="_blank" href={cdhAppStoreLink} rel="noopener noreferrer">
                                <img src={IconApple} alt="icon-app-store" />
                            </a>
                            
                        </div>
                    </div>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export { EarnTower };